jQuery( document ).ready(function($) {
     $('.list-menu__item span').click(function(){
       $(this).closest('.list-menu__item').toggleClass('active_item');
    })
 

  $('.annouce-slider').flickity({
  contain: true,
  pageDots: false,
prevNextButtons: false,
    autoPlay: 5000 ,
    wrapAround: true
});
  var $backToTop = $(".back-to-top");
  $backToTop.hide();
  
  $(window).on('scroll', function() {
    if ($(this).scrollTop() > 100) {
      $backToTop.fadeIn();
    } else {
      $backToTop.fadeOut();
    }
  });
  
  $backToTop.on('click', function(e) {
    $("html, body").animate({scrollTop: 0}, 500);
  });

  $('.product-grid-container').addClass('grid-view-section');
    // Toggle between grid and list view
    $('.grid-view').click(function() {
        $(this).addClass('active');
        $('.list-view').removeClass('active');
        $('.product-grid-container').removeClass('list-view-section1').addClass('grid-view-section');
        $('#product-grid').removeClass('grid--4-col-desktop grid--2-col-tablet-down').addClass('grid--2-col-desktop grid--1-col-tablet-down');
    });
  
    $('.list-view').click(function() {
        $(this).addClass('active');
        $('.grid-view').removeClass('active');
        $('.product-grid-container').removeClass('grid-view-section1').addClass('list-view-section1');
        $('#product-grid').removeClass('grid--2-col-desktop grid--1-col-tablet-down').addClass('grid--4-col-desktop grid--2-col-tablet-down');
      
    });
  });


document.addEventListener("DOMContentLoaded", function () {
  const stickyForm = document.querySelector("product-sticky-form");
  const footer = document.querySelector("footer");

  if (stickyForm && footer) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            stickyForm.style.display = "none";
          } else {
            stickyForm.style.display = "";
          }
        });
      },
      {
        root: null,
        threshold: 0,
      }
    );

    observer.observe(footer);
  }
});

/* HARDDROP PREVIEW NAVIGATION 2026-08-20 */
document.addEventListener('DOMContentLoaded', function () {
  const groups = [
    { title: 'HARDCORE', url: '/collections/hardcore-no-mercy', children: [
      ['ALLE HARDCORE', '/collections/hardcore-no-mercy'],
      ['T-SHIRTS', '/collections/hardcore-t-shirts'],
      ['HOODIES', '/collections/hardcore-hoodies']
    ]},
    { title: 'HARDSTYLE', url: '/collections/hardstyle-energy-mode', children: [
      ['ALLE HARDSTYLE', '/collections/hardstyle-energy-mode'],
      ['T-SHIRTS', '/collections/hardstyle-t-shirts'],
      ['HOODIES', '/collections/hardstyle-hoodies']
    ]},
    { title: 'TECHNO', url: '/collections/techno-dark-system', children: [
      ['ALLE TECHNO', '/collections/techno-dark-system'],
      ['T-SHIRTS', '/collections/techno-t-shirts'],
      ['HOODIES', '/collections/techno-hoodies']
    ]},
    { title: 'VALHALLA', url: '/collections/valhalla', children: [
      ['ALLE VALHALLA', '/collections/valhalla'],
      ['T-SHIRTS', '/collections/valhalla-t-shirt'],
      ['HOODIES', '/collections/vahalla-hoodies']
    ]}
  ];

  const currentPath = window.location.pathname.replace(/\/$/, '') || '/';
  const activeClass = (url) => currentPath === url.replace(/\/$/, '') ? ' is-current' : '';

  const desktop = document.querySelector('.header__inline-menu');
  if (desktop) {
    const groupHtml = groups.map(group => `
      <li class="hd-preview-nav__parent">
        <a class="hd-preview-nav__top${activeClass(group.url)}" href="${group.url}">${group.title}<span class="hd-preview-nav__chevron">⌄</span></a>
        <div class="hd-preview-nav__dropdown">
          ${group.children.map(child => `<a class="hd-preview-nav__child${activeClass(child[1])}" href="${child[1]}">${child[0]}</a>`).join('')}
        </div>
      </li>`).join('');

    desktop.innerHTML = `<ul class="hd-preview-nav" role="list">
      <li><a class="hd-preview-nav__top${activeClass('/collections/neu-im-shop')}" href="/collections/neu-im-shop">NEU</a></li>
      ${groupHtml}
      <li><a class="hd-preview-nav__top${activeClass('/collections/bundles')}" href="/collections/bundles">BUNDLES</a></li>
    </ul>`;
  }

  const mobile = document.querySelector('.menu-drawer__navigation');
  if (mobile) {
    const groupHtml = groups.map(group => `
      <li class="hd-mobile-nav__item">
        <details class="hd-mobile-nav__details">
          <summary class="hd-mobile-nav__summary${activeClass(group.url)}">
            <span>${group.title}</span><span class="hd-mobile-nav__plus" aria-hidden="true">+</span>
          </summary>
          <div class="hd-mobile-nav__submenu">
            ${group.children.map(child => `<a class="hd-mobile-nav__child${activeClass(child[1])}" href="${child[1]}">${child[0]}</a>`).join('')}
          </div>
        </details>
      </li>`).join('');

    mobile.innerHTML = `<ul class="hd-mobile-nav" role="list">
      <li class="hd-mobile-nav__item"><a class="hd-mobile-nav__direct${activeClass('/collections/neu-im-shop')}" href="/collections/neu-im-shop">NEU</a></li>
      ${groupHtml}
      <li class="hd-mobile-nav__item"><a class="hd-mobile-nav__direct${activeClass('/collections/bundles')}" href="/collections/bundles">BUNDLES</a></li>
    </ul>`;
  }

  const style = document.createElement('style');
  style.id = 'harddrop-preview-navigation-styles';
  style.textContent = `
    .hd-preview-nav { display:flex; align-items:center; gap:2.4rem; list-style:none; margin:0; padding:0; }
    .hd-preview-nav > li { position:relative; }
    .hd-preview-nav__top { display:flex; align-items:center; gap:.45rem; padding:1.1rem .2rem; color:inherit; font-size:1.35rem; font-weight:700; letter-spacing:.08em; text-decoration:none; }
    .hd-preview-nav__chevron { font-size:1.5rem; transform:translateY(-1px); }
    .hd-preview-nav__dropdown { position:absolute; z-index:50; left:0; top:100%; min-width:210px; padding:.6rem 0; background:#000; border:1px solid rgba(255,255,255,.18); opacity:0; visibility:hidden; transform:translateY(8px); transition:opacity .16s ease, transform .16s ease, visibility .16s; }
    .hd-preview-nav__parent:hover .hd-preview-nav__dropdown, .hd-preview-nav__parent:focus-within .hd-preview-nav__dropdown { opacity:1; visibility:visible; transform:translateY(0); }
    .hd-preview-nav__child { display:block; padding:1rem 1.4rem; color:#fff !important; font-size:1.25rem; font-weight:600; letter-spacing:.05em; text-decoration:none; }
    .hd-preview-nav__child:hover, .hd-preview-nav__child:focus, .hd-preview-nav__top.is-current, .hd-preview-nav__child.is-current { background:#fff; color:#000 !important; }
    .hd-mobile-nav { list-style:none; margin:0; padding:0 1.6rem 2.4rem; }
    .hd-mobile-nav__item { border-bottom:1px solid rgba(255,255,255,.15); }
    .hd-mobile-nav__direct, .hd-mobile-nav__summary { min-height:58px; display:flex; align-items:center; justify-content:space-between; width:100%; padding:0 .2rem; color:#fff !important; font-size:1.55rem; font-weight:700; letter-spacing:.08em; text-transform:uppercase; text-decoration:none; cursor:pointer; list-style:none; }
    .hd-mobile-nav__summary::-webkit-details-marker { display:none; }
    .hd-mobile-nav__plus { font-size:2.2rem; font-weight:400; transition:transform .18s ease; }
    .hd-mobile-nav__details[open] .hd-mobile-nav__plus { transform:rotate(45deg); }
    .hd-mobile-nav__submenu { padding:0 0 .8rem; }
    .hd-mobile-nav__child { display:block; padding:1.05rem 1.2rem; color:#fff !important; font-size:1.35rem; font-weight:500; letter-spacing:.05em; text-decoration:none; border-left:2px solid rgba(255,255,255,.2); }
    .hd-mobile-nav__direct.is-current, .hd-mobile-nav__summary.is-current, .hd-mobile-nav__child.is-current { background:#fff; color:#000 !important; padding-left:1rem; }
    @media screen and (max-width: 989px) {
      .header { padding-top:12px !important; padding-bottom:12px !important; }
      .header__heading-logo { max-width:150px !important; }
      .menu-drawer__navigation { padding-top:1rem !important; }
    }
    @media screen and (min-width: 990px) and (max-width: 1200px) {
      .hd-preview-nav { gap:1.3rem; }
      .hd-preview-nav__top { font-size:1.2rem; }
    }
  `;
  document.head.appendChild(style);

  /* Preview-only storefront copy fix. Checkout shipping settings remain untouched. */
  const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT);
  const nodes = [];
  let node;
  while ((node = walker.nextNode())) nodes.push(node);
  nodes.forEach(textNode => {
    if (/150\s*€/.test(textNode.nodeValue || '')) {
      textNode.nodeValue = textNode.nodeValue.replace(/ab\s*150\s*€/gi, 'ab 79 €');
    }
  });
});
